var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-circle bg-white avatar-wrapper ml-auto mr-auto p-4"},[_c('font-awesome-icon',{staticClass:"fs-47",attrs:{"icon":"user"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }